<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import AreaHeatmap from '@components/area-heatmap'
import axios from 'axios'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import {
  RIYADH_AREA_DATA,
  REGAL_EYES_CAMPAIGN_ID,
  REGAL_EYES_CAMPAIGN_NAME,
} from '@utils/regal-eyes'

const HEATMAP_METRICS = [
  { key: 'spend',       label: 'Spend' },
  { key: 'impressions', label: 'Impressions' },
  { key: 'clicks',      label: 'Clicks' },
]

const MAP_VIEW_CAMPAIGNS = [
  { id: REGAL_EYES_CAMPAIGN_ID, label: REGAL_EYES_CAMPAIGN_NAME },
]

export default {
  page: {
    title: 'Map View Report',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, Treeselect, AreaHeatmap },
  methods: {
    editReport: function () {
      this.PageComponents.ajax_loading = false
      this.PageComponents.hasError = false
      this.PageComponents.show_results = false
    },
    utilities() {
      this.apiUrl = appConfig.api
      this.PageComponents.ajax_loading = true
      this.PageComponents.hasError = false

      var uinfo = JSON.parse(localStorage['auth.currentUser'])
      if (uinfo.advertiser !== undefined) {
        this.PageComponents.selected_advertiser = {
          name: uinfo.advertiser.name,
          id: uinfo.advertiser.id,
        }
      } else {
        this.PageComponents.selected_advertiser = { name: '', id: 0 }
      }

      this.PageComponents.utilities_loading = true
      axios
        .post(appConfig.api + 'reports/report_utilities/?type=geo', {
          uinfo: JSON.parse(localStorage.getItem('auth.currentUser')),
        })
        .then((response) => {
          this.advertisers = response.data.advertisers_list
          this.campaign_list = MAP_VIEW_CAMPAIGNS
          this.PageComponents.ajax_loading = false
        })
        .catch(() => {
          this.campaign_list = MAP_VIEW_CAMPAIGNS
          this.PageComponents.ajax_loading = false
        })
    },
    runReport: function () {
      this.PageComponents.ajax_loading = true
      this.PageComponents.hasError = false

      setTimeout(() => {
        this.results.data = RIYADH_AREA_DATA.map((row) => ({
          ...row,
          ctr: row.impressions > 0 ? row.clicks / row.impressions : 0,
        }))

        this.results.totals = this.results.data.reduce(
          (acc, row) => {
            acc.spend += row.spend
            acc.impressions += row.impressions
            acc.clicks += row.clicks
            return acc
          },
          { spend: 0, impressions: 0, clicks: 0 }
        )
        this.results.totals.ctr =
          this.results.totals.impressions > 0
            ? this.results.totals.clicks / this.results.totals.impressions
            : 0

        this.PageComponents.ajax_loading = false
        this.PageComponents.show_results = true
      }, 400)
    },
    setHeatmapMetric(metricKey) {
      this.heatmapMetric = metricKey
    },
    formatNumber(val) {
      if (val === null || val === undefined || isNaN(val)) return '-'
      return Number(val).toLocaleString()
    },
    formatCurrency(val) {
      if (val === null || val === undefined || isNaN(val)) return '-'
      return Number(val).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
    formatPct(val) {
      if (val === null || val === undefined || isNaN(val)) return '-'
      return (Number(val) * 100).toFixed(3) + '%'
    },
  },
  mounted: function () {
    this.utilities()
  },
  data() {
    return {
      title: 'Map View Report',
      campaign_list: [],
      advertisers: [],
      apiUrl: '',
      heatmapMetric: 'spend',
      heatmapMetrics: HEATMAP_METRICS,
      report: {
        advertisers: [],
        campaigns: [],
      },
      results: {
        data: [],
        totals: { spend: 0, impressions: 0, clicks: 0, ctr: 0 },
      },
      items: [
        { text: 'Dashboard', href: '/' },
        { text: 'Reports' },
        { text: 'Map View Report' },
      ],
      PageComponents: {
        ajax_loading: false,
        show_results: false,
        hasError: false,
        errorMsgs: [],
      },
    }
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-alert variant="danger" show dismissible v-show="PageComponents.hasError">
      <ul>
        <li v-for="error in PageComponents.errorMsgs" :key="error">{{ error }}</li>
      </ul>
    </b-alert>

    <!-- Report form -->
    <div class="row" v-if="PageComponents.ajax_loading == false && PageComponents.show_results == false">
      <div class="col-lg-12">
        <form>
          <div class="card">
            <div class="card-body">
              <h6 class="header-title mb-3">Report Filters</h6>

              <div class="row">
                <div class="col">
                  <b-form-group label-cols-sm="10" label-cols-lg="2" label="Advertiser">
                    <treeselect
                      v-model="report.advertisers"
                      placeholder="All"
                      :multiple="true"
                      :options="advertisers"
                    />
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <b-form-group label-cols-sm="10" label-cols-lg="2" label="Campaign">
                    <treeselect
                      placeholder="All"
                      v-model="report.campaigns"
                      :multiple="true"
                      :options="campaign_list"
                    />
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <button type="button" class="btn btn-primary" v-on:click="runReport()">Run</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- /Report form -->

    <!-- Loading -->
    <div class="row" v-show="PageComponents.ajax_loading">
      <div class="text-center" style="margin: auto; padding-top: 23px;">
        <div class="text-muted font-size-13">Please wait ...</div>
        <br />
        <b-spinner label="Loading..." variant="primary" class="ml-3"></b-spinner>
      </div>
    </div>
    <!-- /Loading -->

    <!-- Report results -->
    <div class="row" v-if="PageComponents.ajax_loading == false && PageComponents.show_results == true">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center mb-3">
              <div class="col">
                <h4 class="header-title mt-0 mb-1">Map View Report</h4>
                <p class="text-muted mb-0">Delivery across Riyadh districts</p>
              </div>
              <div class="col text-right">
                <button type="button" class="btn btn-primary" v-on:click="editReport()">Edit</button>
              </div>
            </div>

            <div class="d-flex align-items-center mb-2">
              <span class="text-muted mr-2 font-size-13">Heatmap by:</span>
              <b-button-group size="sm">
                <b-button
                  v-for="m in heatmapMetrics"
                  :key="m.key"
                  :variant="heatmapMetric === m.key ? 'primary' : 'outline-primary'"
                  @click="setHeatmapMetric(m.key)"
                >
                  {{ m.label }}
                </b-button>
              </b-button-group>
            </div>

            <area-heatmap :data="results.data" :metric="heatmapMetric" height="560px" />
          </div>
        </div>

        <!-- Delivery table -->
        <div class="card">
          <div class="card-body">
            <h5 class="header-title mb-3">Delivery by Area</h5>
            <div class="table-responsive">
              <table class="table table-sm table-hover mb-0">
                <thead>
                  <tr>
                    <th>Area</th>
                    <th class="text-right">Spend</th>
                    <th class="text-right">Impressions</th>
                    <th class="text-right">CTR</th>
                    <th class="text-right">Clicks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in results.data" :key="row.area">
                    <td>{{ row.area }}</td>
                    <td class="text-right">{{ formatCurrency(row.spend) }}</td>
                    <td class="text-right">{{ formatNumber(row.impressions) }}</td>
                    <td class="text-right">{{ formatPct(row.ctr) }}</td>
                    <td class="text-right">{{ formatNumber(row.clicks) }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="font-weight-bold">
                    <td>Total</td>
                    <td class="text-right">{{ formatCurrency(results.totals.spend) }}</td>
                    <td class="text-right">{{ formatNumber(results.totals.impressions) }}</td>
                    <td class="text-right">{{ formatPct(results.totals.ctr) }}</td>
                    <td class="text-right">{{ formatNumber(results.totals.clicks) }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Report results -->
  </Layout>
</template>
